import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "../ui/templates/layouts/AuthLayout";
import Login from "../pages/login";
import SignUpPage from "../ui/pages/SignUpPage";
import RequestCode from "../ui/pages/RequestCode";
import VestelIdentity from "../ui/pages/VestelIdentity";
import ConfirmUser from "../pages/confirmUser";
import ForgotPassword from "../ui/pages/ForgotPassword";
import DeleteAccount from "../ui/pages/DeleteAccount";
import SignInPage from "../ui/pages/SignInPage";
import EmailVerification from "../ui/pages/EmailVerification";
import OAuthCallback from "../ui/pages/OAuthCallback";
import SmsLogin from "../ui/pages/SmsLogin";
import FAQ from "../ui/pages/FAQ";
import Retail from "../ui/pages/Retail";
import AppLayout from "../ui/templates/layouts/AppLayout";

const SignInRoute = () => (
  <Routes>
    <Route path="/oauth-callback" element={<OAuthCallback />} />
    <Route element={<AuthLayout />}>
      <Route path="/login" element={<Login />} />
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="/request-code" element={<RequestCode />} />
      <Route path="/sms-login" element={<SmsLogin />} />
      <Route path="/vestel-identity" element={<VestelIdentity />} />
      <Route path="/confirmuser" element={<ConfirmUser />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/support" element={<FAQ />} />
      <Route path="/" element={<SignInPage />} />
      <Route path="/email-verification" element={<EmailVerification />} />
      <Route path="/magazacilik" element={<Retail />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Route>
    
    <Route element={<AppLayout />}>
      <Route path="/user-delete" element={<DeleteAccount />} />
    </Route>
  </Routes>
);

export default SignInRoute;
